// Scroll Spy

var scrollSpy = {
  wrap_el: $(document),

  init: function (scroll_wrap_el) {
    var s = this;
    var nav_el = $('.spynav');
    var li_el = nav_el.find('li');
    var a_el = nav_el.find('li a');

    if (scroll_wrap_el) s.wrap_el = scroll_wrap_el;

    a_el.each(function(){
      var id = $(this).attr('href');
      $(id).addClass('js-spy');
    });

    var spy_els = $('.js-spy');

    var spyInit = function() {
      var window_h = $(window).height();

      spy_els.each(function(i){
        var el = $(this);
        var rect = el[0].getBoundingClientRect();
        var top = rect.top;
        var btm = rect.bottom;

        if ( top == 0 || (top > 0 && top <= window_h/2) || (btm > window_h/2 && btm <= window_h) || (top < 0 && btm > window_h) ) {
          // nav_el.find('.active').removeClass('active');
          li_el.eq(i).addClass('active');
        } else {
          li_el.eq(i).removeClass('active');
        }
      });

      nav_el.find('li.active').each(function (i) {
        if (i > 0) $(this).removeClass('active');
      });
    }

    spyInit();
    s.wrap_el.off('scroll.spy').on('scroll.spy', spyInit);
    $(window).off('resize.spy').on('resize.spy', spyInit);

    a_el.each(function () {
      var th = $(this);
      var link_el = $(th.attr('href'));

      th.click(function (e) {
        var window_w = $(window).width();
        var window_h = $(window).height();
        e.preventDefault();
        // link_el[0].scrollIntoView({ behavior: 'smooth' });
        var navbar_h = window_w < 768 && window_w < window_h ? 150 : 90;
        s.wrap_el.scrollTo(link_el, 0, {
          offset: {top: -navbar_h}
        });
      });
    });
  },

  kill: function () {
    scrollSpy.wrap_el.off('scroll.spy');
    $(window).off('resize.spy');
  }
}